export default "__VITE_PUBLIC_ASSET__7a5a1d0a__"